import React from 'react'
import { Text } from '../Text'
import { TextLink } from '../TextLink'
import { IProps } from './index'

export const Tag: React.FC<IProps> = ({ text, url }) => {
  return (
    <TextLink url={url} newWindow={false}>
      <Text brand="default" size="caption">
        {text}
      </Text>
    </TextLink>
  )
}
